import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$contentTemplates} from "../../$content-templates.factory";

export class ContentTemplateSelectComponent implements IController {

  selectedTemplateId: any;
  options: any[];
  optionIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  onChange: Function;


  private contentTemplatesRef: any;
  public selectedContentTemplate: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $contentTemplates: $contentTemplates) {
    this.contentTemplatesRef = this.$contentTemplates();
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if ((changes.selectedTemplateId && !changes.selectedTemplateId.isFirstChange())) {
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedTemplateId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'branch-ids="ctrl.branchIdsRef" ' +
        'depot-ids="ctrl.depotIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'content-templates';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({contentTemplate: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const contentTemplate = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({contentTemplate: contentTemplate, id: selectedId});
            panel.destroy();
          } else {
            this.contentTemplatesRef.$asyncValues([selectedId])
              .then((contentTemplates) => {
                this.onChange({contentTemplate: contentTemplates[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({contentTemplate: undefined});
  }

  private _setSelected() {
    if (!!this.selectedTemplateId) {
      if (!!this.options) {
        this.selectedContentTemplate = _.find(this.options, (o) => {
          return o.id === this.selectedTemplateId;
        });
        this._setSelectedText();
      } else {
        this.contentTemplatesRef.$asyncValues([this.selectedTemplateId])
          .then((contentTemplates) => {
            this.selectedContentTemplate = _.orderBy(contentTemplates, ['name'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedContentTemplate = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedContentTemplate, 'name', '');
  }


}

angular
  .module('bringoz.admin.content-templates')
  .component('contentTemplateSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedTemplateId: '<',
      options: '<?',
      optionIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./content-template-select.html').default,
    controller: ContentTemplateSelectComponent
  });
